export const flooriSpritePath = 'assets/sprites';
